import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";
import { Breadcrumb, Table, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useUrlSearchParams } from "use-url-search-params";
import { useList } from "modules/serviceRegister/hooks";
import Pagination from "containers/Pagination";
import FilterList from "./components/FilterList";
import Button from "components/Button";
import * as Icons from "assets/icons";
import { useNavigate } from "react-router";
import config from "../../config";
import ExcelDownload from "./components/ExcelDownload";

// import QuickViewModal from "./components/QuickViewModal";


const ServiceRegister = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [params, setParams] = useUrlSearchParams();
  // const [page, setPage] = useState(0);
  const [search, setSearch] = useState(0);
  // const [isModal, setModal] = useState({})

  const defaultParams = {
    search,
    page: params.page,
    filter: [
      {
        key: "organization_id",
        operation: "=",
        value: params.organization_id,
        type: "STRING",
      },
      {
        key: "function_name.sphere.id",
        operation: "=",
        value: params.sphere_id,
        type: "NUMBER",
      },
      {
        key: `service_name`,
        operation: "%_%",
        value: params.service_name,
        type: "JSON",
      },
      {
        key: "service_form",
        operation: "=",
        value: params.service_form,
        type: "STRING",
      },
      {
        key: "subject_type",
        operation: "=",
        value: params.subject_type,
        type: "STRING",
      },
      {
        key: "payment_type",
        operation: "=",
        value: params.payment_type,
        type: "STRING",
      },
    ],
  }
  const { items, meta, isFetched } = useList({
    params: defaultParams
  });

  return (
    <>
      <Container>
        <Spacer size={35} />

        <Breadcrumb separator=">">
          <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("service_register")}</Breadcrumb.Item>
        </Breadcrumb>

        <Spacer size={32} />

        <Title align="left" text={t("service_register")} />
        <Spacer size={40} />

        <Flex>
          <FilterList {...{ params, setParams, setSearch }} />
          <ExcelDownload defaultParams={defaultParams} />
        </Flex>

        <Spacer size={20} />
        <Table
          rowKey="id"
          defaultSort="-id"
          columns={[
            {
              title: "№",
              render: (text, record, index) =>
                (meta.current - 1) * meta.perPage + index + 1,
            },
            {
              key: "uniqueNumber",
              title: t("column_unique_number"),
              dataIndex: ["uniqueNumber"],
            },
            {
              key: "service_name",
              title: t("column_service_name"),
              dataIndex: ["serviceName", i18n.language],
            },
            {
              key: "users_type",
              title: t("column_users_type"),
              dataIndex: ["subjectType"],
              render: value => t(value)
            },
            {
              key: "service_form",
              title: t("column_service_form"),
              dataIndex: ["serviceForm"],
              render: value => t(value)
            },

            {
              key: "paymentType",
              title: t("column_with_payment"),
              dataIndex: ["paymentType"],
              render: value => t(value)
            },
            {
              key: "service_response",
              title: t("column_service_response"),
              dataIndex: ["serviceResult"],
            },
            {
              key: "actions",
              render: (_, record) => (
                <Button
                  background="secondary"
                  color="secondary"
                  border="none"
                  radius="xs"
                  iconOnly
                  onClick={() => {
                    navigate(`/service-register/view/${record.id}`);
                  }}>
                  <Icons.ArrowRight />
                </Button>
              ),
            },
          ]}
          dataSource={items}
          pagination={false}
          loading={!isFetched}
          onRow={record => {
            return {
              onClick: event => {
                if (event.target.localName === "td")
                  navigate(`/service-register/view/${record.id}`);
              },
            };
          }}
          scroll={{ x: 1400 }}
        />

        <Spacer size={32} />

        <Pagination
          current={meta.current}
          total={meta.totalPages}
          currentItems={items.length}
          totalItems={meta.totalItems}
          onChange={(page) => setParams({ page })}
        />

        <Spacer size={140} />
      </Container>
      {/*<QuickViewModal item={isModal} onCancel={() => setModal({})} />*/}
    </>
  );
};

export default ServiceRegister;
